import styled from 'styled-components';

import * as colors from '../../util/colors';

export const Toolbar = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  margin: 24px 0 16px;
`;

export const Title = styled.h1`
  margin: 0 0 6px;
  color: ${colors.TEXT_TITLE};
  font-size: 24px;
  line-height: 1.25;
`;

export const Description = styled.p`
  margin: 0;
  color: ${colors.TEXT_MINOR};
  font-size: 14px;
  line-height: 1.5;
`;

export const Tabs = styled.nav`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 24px 0 0;
`;

export const Tab = styled.button`
  min-height: 44px;
  padding: 0 18px;
  border: 1px solid ${props => props.active ? colors.BLUE_MAIN : colors.INPUT_STROKE};
  border-radius: 6px;
  color: ${props => props.active ? '#fff' : colors.TEXT_MAIN};
  background: ${props => props.active ? colors.BLUE_MAIN : '#fff'};
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  &:focus { outline: 3px solid ${colors.BLUE_LIGHT}; }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: ${props => props.columns || 'minmax(280px, 0.85fr) minmax(420px, 1.4fr)'};
  gap: 24px;
  align-items: start;
  margin-bottom: 32px;
  @media screen and (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`;

export const Card = styled.section`
  min-width: 0;
  padding: ${props => props.padding || '24px'};
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 1px 15px rgba(217, 226, 232, 0.8);
`;

export const CardTitle = styled.h2`
  margin: 0 0 16px;
  color: ${colors.TEXT_TITLE};
  font-size: 18px;
`;

export const State = styled.div`
  padding: 28px 20px;
  border: 1px dashed ${props => props.error ? colors.ERROR : colors.INPUT_STROKE};
  border-radius: 8px;
  color: ${props => props.error ? colors.ERROR : colors.TEXT_MINOR};
  background: ${props => props.error ? '#fff5f3' : colors.BG};
  line-height: 1.5;
  text-align: ${props => props.left ? 'left' : 'center'};
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ListButton = styled.button`
  width: 100%;
  min-height: 56px;
  padding: 12px 14px;
  border: 1px solid ${props => props.active ? colors.BLUE_MAIN : colors.LINE};
  border-radius: 7px;
  color: ${colors.TEXT_MAIN};
  background: ${props => props.active ? colors.BLUE_LIGHT : '#fff'};
  cursor: pointer;
  text-align: left;
  &:focus { outline: 3px solid ${colors.BLUE_LIGHT}; }
`;

export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 4px 9px;
  border-radius: 999px;
  color: ${props => props.danger ? colors.ERROR : props.success ? colors.GREEN_DARK : colors.BLUE_DARK};
  background: ${props => props.danger ? '#fff0ed' : props.success ? '#ecf9e7' : colors.BLUE_LIGHT};
  font-size: 12px;
  font-weight: 700;
  line-height: 1.3;
`;

export const FieldGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(${props => props.columns || 2}, minmax(0, 1fr));
  gap: 16px;
  @media screen and (max-width: 760px) { grid-template-columns: 1fr; }
`;

export const Field = styled.label`
  display: flex;
  flex-direction: column;
  gap: 7px;
  /* bootstrap reboot задаёт label { margin-bottom: .5rem } — из-за него поле
     оказывается выше кнопок в той же строке фильтров. */
  margin-bottom: 0;
  color: ${colors.TEXT_MAIN};
  font-size: 13px;
  font-weight: 600;
`;

export const CheckboxRow = styled.span`
  display: flex;
  align-items: center;
  min-height: 44px;
  gap: 10px;
  font-weight: 400;
  input { width: 20px; height: 20px; }
`;

export const Input = styled.input`
  min-height: 44px;
  padding: 9px 12px;
  border: 1px solid ${colors.INPUT_STROKE};
  border-radius: 5px;
  color: ${colors.TEXT};
  background: #fff;
  font: inherit;
  &:focus { outline: 3px solid ${colors.BLUE_LIGHT}; border-color: ${colors.BLUE_MAIN}; }
`;

export const Select = styled.select`
  min-height: 44px;
  padding: 9px 12px;
  border: 1px solid ${colors.INPUT_STROKE};
  border-radius: 5px;
  color: ${colors.TEXT};
  background: #fff;
  font: inherit;
  &:focus { outline: 3px solid ${colors.BLUE_LIGHT}; border-color: ${colors.BLUE_MAIN}; }
`;

export const Textarea = styled.textarea`
  min-height: ${props => props.short ? '80px' : '112px'};
  padding: 10px 12px;
  border: 1px solid ${colors.INPUT_STROKE};
  border-radius: 5px;
  resize: vertical;
  font: inherit;
  line-height: 1.5;
  &:focus { outline: 3px solid ${colors.BLUE_LIGHT}; border-color: ${colors.BLUE_MAIN}; }
`;

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 20px;
`;

export const ActionButton = styled.button`
  min-height: 44px;
  padding: 0 18px;
  border: 1px solid ${props => props.danger ? colors.ERROR : colors.BLUE_MAIN};
  border-radius: 5px;
  color: ${props => props.primary ? '#fff' : props.danger ? colors.ERROR : colors.BLUE_MAIN};
  background: ${props => props.primary ? colors.BLUE_MAIN : '#fff'};
  cursor: ${props => props.disabled ? 'default' : 'pointer'};
  font-size: 14px;
  font-weight: 700;
  opacity: ${props => props.disabled ? 0.48 : 1};
  &:focus { outline: 3px solid ${colors.BLUE_LIGHT}; }
`;

export const ErrorText = styled.div`
  margin: 16px 0;
  color: ${colors.ERROR};
  line-height: 1.5;
`;

export const SuccessText = styled.div`
  margin: 16px 0;
  color: ${colors.GREEN_DARK};
  line-height: 1.5;
`;

export const Scroll = styled.div`
  overflow-x: auto;
`;

export const Table = styled.table`
  width: 100%;
  min-width: ${props => props.minWidth || '720px'};
  border-collapse: collapse;
  th, td { padding: 12px; border-bottom: 1px solid ${colors.LINE}; text-align: left; vertical-align: top; }
  th { color: ${colors.TEXT_MINOR}; background: ${colors.BG}; font-size: 12px; }
  td { color: ${colors.TEXT_MAIN}; font-size: 14px; }
`;

export const DefinitionList = styled.dl`
  display: grid;
  grid-template-columns: minmax(150px, 0.35fr) 1fr;
  gap: 10px 18px;
  margin: 0;
  dt { color: ${colors.TEXT_MINOR}; }
  dd { margin: 0; color: ${colors.TEXT_MAIN}; overflow-wrap: anywhere; }
  @media screen and (max-width: 620px) { grid-template-columns: 1fr; gap: 4px; dd { margin-bottom: 10px; } }
`;
